import { useNavigate } from 'react-router-dom'
import LeftLeafSVG from '../icons/LeftLeafSVG'
import RightLeafSVG from '../icons/RightLeafSVG'
import RenderHTML from './ui-components/RenderHTML'
import { useBottomSheet } from '../state-management/contexts/BottomSheetContext'
import { RestrictedAccessInfoBottomSheet } from '../features/new-elite-landing/components/RestrictedAccessInfoBottomSheet'

const EliteLabelSvg = `<svg width="42" height="15" viewBox="0 0 42 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M-0.000214144 14.3153V0.553628H10.3211V2.84725H2.84704V5.89222H9.92562V8.18584H2.84704V11.9822H10.4002V14.3153H-0.000214144ZM12.8376 14.3153V-4.56072e-06H15.3685V14.3153H12.8376ZM18.2966 14.3153V4.50814H20.8275V14.3153H18.2966ZM19.3445 2.92634C18.9359 2.92634 18.5932 2.79452 18.3164 2.53089C18.0527 2.25407 17.9209 1.91134 17.9209 1.50271V1.42362C17.9209 1.01499 18.0527 0.678854 18.3164 0.41522C18.5932 0.138404 18.9359 -4.56072e-06 19.3445 -4.56072e-06H19.7795C20.1882 -4.56072e-06 20.5243 0.138404 20.7879 0.41522C21.0647 0.678854 21.2031 1.01499 21.2031 1.42362V1.50271C21.2031 1.89816 21.0647 2.2343 20.7879 2.51111C20.5243 2.78793 20.1882 2.92634 19.7795 2.92634H19.3445ZM24.2795 10.4992V6.56449H22.5593V4.50814H24.3586V1.52248H26.7511V4.50814H29.5983V6.56449H26.8104V10.4992H24.2795ZM28.3724 14.5526C26.9884 14.5526 25.9602 14.1901 25.2879 13.4651C24.6156 12.7401 24.2795 11.8108 24.2795 10.6772V10.4992H26.8104V10.7365C26.8104 11.277 26.9752 11.6922 27.3047 11.9822C27.6343 12.259 28.1022 12.3974 28.7086 12.3974C29.1567 12.3974 29.6445 12.3315 30.1717 12.1997V14.3153C29.5917 14.4735 28.992 14.5526 28.3724 14.5526ZM30.7753 9.39197C30.7753 8.33743 30.9928 7.42789 31.4278 6.66335C31.876 5.88563 32.5087 5.29245 33.326 4.88382C34.1432 4.47519 35.0923 4.27087 36.1732 4.27087C37.32 4.27087 38.2823 4.49496 39.06 4.94314C39.8377 5.39132 40.4177 6.00427 40.8 6.78199C41.1823 7.54653 41.3734 8.40334 41.3734 9.35242C41.3734 9.57651 41.3602 9.84674 41.3339 10.1631H32.0803L33.4248 9.07561C33.2535 10.2224 33.4116 11.0924 33.8994 11.6856C34.4003 12.2656 35.1516 12.5556 36.1534 12.5556C36.7993 12.5556 37.3332 12.4304 37.755 12.1799C38.19 11.9294 38.4932 11.6131 38.6646 11.2308H41.2745C41.0373 12.259 40.4902 13.0697 39.6334 13.6628C38.7766 14.256 37.6364 14.5526 36.2128 14.5526C34.5123 14.5526 33.181 14.111 32.2187 13.2278C31.2564 12.3315 30.7753 11.0529 30.7753 9.39197ZM33.3655 9.43151L32.0803 8.5022H38.8623C38.8623 7.82993 38.6316 7.2763 38.1702 6.84131C37.7089 6.39313 37.0432 6.16904 36.1732 6.16904C35.1714 6.16904 34.4266 6.47222 33.9389 7.07858C33.4512 7.68494 33.2601 8.46925 33.3655 9.43151Z" fill="#BB4F22"/>
</svg>`

const ChevronRightIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M6 4L10 8L6 12" stroke="#65321D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

export function MutualFundLockedOverlay() {
  const navigate = useNavigate()
  const { openBottomSheet, closeBottomSheet } = useBottomSheet()

  const handleRenewEliteClick = () => {
    navigate('/new-elite-dashboard')
  }

  const handleRestrictedAccessInfoClick = () => {
    openBottomSheet(<RestrictedAccessInfoBottomSheet onDismiss={closeBottomSheet} />)
  }

  return (
    <div className='relative z-[1] flex w-full flex-col items-center px-5 py-6 mt-16'>
      <div className='flex w-full max-w-[250px] flex-col items-center rounded-2xl bg-white px-5 py-6 shadow-[0_8px_32px_rgba(35,35,35,0.12)]'>
        <div className='mb-4 flex flex-row items-center justify-center'>
          <LeftLeafSVG color='#BB4F2266' size={18} />
          <span className='pt-[2px] text-[#BB4F22]'>
            <RenderHTML innerHTMLText={EliteLabelSvg} />
          </span>
          <RightLeafSVG color='#BB4F2266' size={18} />
        </div>
        <p className='mb-3 text-center text-lg font-medium leading-[1.35] text-[#65321D]'>
          Your access is restricted for Elite insights and other features
        </p>
        <p className='mb-5 text-center text-sm font-normal leading-[1.45] text-[#6A6E6E]'>
          Unlock Elite insights, Scores, Rank trends and more with Elite
        </p>
        <div
          className='mb-4 flex cursor-pointer items-center gap-3 rounded-xl bg-[#FFF2DF] px-4 py-3'
          onClick={handleRenewEliteClick}
        >
          <span className='flex-1 text-sm font-medium text-[#65321D]'>Renew Elite to unlock</span>
          <RenderHTML innerHTMLText={ChevronRightIcon} />
        </div>
        <div
          className='cursor-pointer text-center text-sm text-[rgba(101,50,29,0.60)] underline'
          onClick={handleRestrictedAccessInfoClick}
        >
          Why is my access restricted?
        </div>
      </div>
    </div>
  )
}
